// extracted by mini-css-extract-plugin
export default {"box":"z_aT1x","profile":"GDefAm"};